import React, { useState, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { HiDownload, HiEye, HiEyeOff } from "react-icons/hi";
import { BsFileEarmarkPdf } from "react-icons/bs";
import pdf from "../../Assets/Resume.pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeSection() {
  const [show,     setShow]     = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageW,    setPageW]    = useState(800);
  const wrapRef                 = useRef(null);

  /* Track container width for responsive scaling */
  useEffect(() => {
    function measure() {
      if (wrapRef.current) {
        setPageW(wrapRef.current.clientWidth);
      }
    }
    measure();
    const ro = new ResizeObserver(measure);
    if (wrapRef.current) ro.observe(wrapRef.current);
    return () => ro.disconnect();
  }, [show]); // re-measure when viewer opens

  /* Scale so the PDF fills the container but never exceeds 1:1 */
  const scale = Math.min(pageW / 612, 1.5); // 612px = PDF pts-width

  return (
    <section id="resume" className="resume-section">
      <div className="resume-container">

        {/* ── Header ── */}
        <div className="resume-header">
          <div>
            <span className="section-label">Resume</span>
            <h2 className="section-title">
              My <span>Resume</span>
            </h2>
            <p className="resume-subtitle">
              View or download my latest CV covering experience, skills, and projects.
            </p>
          </div>

          {/* Action buttons */}
          <div className="resume-actions">
            <button
              className={`resume-toggle-btn${show ? " active" : ""}`}
              onClick={() => setShow((v) => !v)}
              aria-expanded={show}
            >
              {show ? <HiEyeOff /> : <HiEye />}
              {show ? "Hide Resume" : "View Resume"}
            </button>

            <a
              href={pdf}
              target="_blank"
              rel="noreferrer"
              download
              className="btn-primary-custom"
            >
              <HiDownload />
              Download CV
            </a>
          </div>
        </div>

        {/* ── Collapsed placeholder card (shown when hidden) ── */}
        {!show && (
          <div className="resume-placeholder" onClick={() => setShow(true)} role="button" tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setShow(true)}
            aria-label="Click to view resume"
          >
            <BsFileEarmarkPdf className="resume-placeholder-icon" />
            <div>
              <p className="resume-placeholder-title">Resume PDF</p>
              <p className="resume-placeholder-sub">Click "View Resume" to open the preview</p>
            </div>
          </div>
        )}

        {/* ── PDF Viewer ── */}
        {show && (
          <div className="resume-viewer-wrap" ref={wrapRef}>
            <Document
              file={pdf}
              onLoadSuccess={({ numPages: n }) => setNumPages(n)}
              loading={
                <div className="resume-loading">
                  <div className="resume-spinner" />
                  <span>Loading resume…</span>
                </div>
              }
              error={
                <div className="resume-error">
                  <BsFileEarmarkPdf />
                  <span>Could not load PDF. <a href={pdf} target="_blank" rel="noreferrer">Open directly ↗</a></span>
                </div>
              }
            >
              {Array.from({ length: numPages || 0 }, (_, i) => (
                <div key={i + 1} className="resume-page-wrap">
                  <Page
                    pageNumber={i + 1}
                    scale={scale}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </div>
              ))}
            </Document>

            {/* Bottom close / download bar */}
            <div className="resume-viewer-bar">
              <button className="resume-toggle-btn active" onClick={() => setShow(false)}>
                <HiEyeOff /> Hide Resume
              </button>
              <a href={pdf} target="_blank" rel="noreferrer" download className="btn-primary-custom">
                <HiDownload /> Download CV
              </a>
            </div>
          </div>
        )}

      </div>
    </section>
  );
}

export default ResumeSection;
